import { useMemo } from 'react';
var TOKENS = /[xy]/g;
var uuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(TOKENS, c => {
  var r = Math.random() * 16 | 0;
  var v = c === 'x' ? r : r & 0x3 | 0x8;
  return v.toString(16);
});
export var useUniqueFormIdentifier = _ref => {
  var {
    name,
    fallbackName
  } = _ref;
  var generatedName = useMemo(() => "".concat(fallbackName, "-").concat(uuid()), [fallbackName]);
  return name ? name : generatedName;
};
//# sourceMappingURL=index.js.map